import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'configuration-update-password',
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule, ButtonModule, MessageModule, ToastModule],
    templateUrl: './configuration-update-password.component.html',
    styleUrl: './configuration-update-password.component.less',
    providers: [MessageService],
})
export class ConfigurationUpdatePasswordComponent {
    updatePasswordForm: FormGroup;
    errorMessages = {
        oldPassword: {
            required: 'Please fill in your old password',
            minlength: 'Old password length must be at least 6 characters',
        },
        newPassword: {
            required: 'Please fill in your new password',
            minlength: 'New password length must be at least 6 characters',
        },
        confirmPassword: {
            required: 'Please fill in your confirm password',
            passwordMismatch: 'Confirm passwords do not match',
        },
    };
    constructor(
        private formBuilder: FormBuilder,
        private http: HttpClient,
        private messageService: MessageService
    ) {
        this.updatePasswordForm = this.formBuilder.group({
            oldPassword: ['', [Validators.required, Validators.minLength(6)]],
            newPassword: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required]],
        });

        this.updatePasswordForm.valueChanges.subscribe(() => {
            this.passwordMatchValidator();
        });
    }

    passwordMatchValidator() {
        const newPassword = this.updatePasswordForm.get('newPassword')?.value;
        const confirmPassword = this.updatePasswordForm.get('confirmPassword')?.value;
        const confirmControl = this.updatePasswordForm.get('confirmPassword');

        if (newPassword && confirmPassword && newPassword !== confirmPassword) {
            confirmControl?.setErrors({ ...confirmControl.errors, passwordMismatch: true });
        } else if (confirmControl?.errors?.['passwordMismatch']) {
            const { passwordMismatch, ...errors } = confirmControl.errors;
            confirmControl.setErrors(Object.keys(errors).length ? errors : null);
        }
    }

    getErrors(controlName: keyof typeof this.errorMessages): string[] {
        const control = this.updatePasswordForm.get(controlName);
        const errorMessages = this.errorMessages[controlName];

        if (!control || !control.errors || (!control.dirty && !control.touched) || !errorMessages) return [];

        return Object.keys(control.errors)
            .filter((errorType) => errorType in errorMessages)
            .map((errorType) => errorMessages[errorType as keyof typeof errorMessages]);
    }

    updatePassword() {
        if (this.updatePasswordForm.invalid) return;

        const { oldPassword, newPassword } = this.updatePasswordForm.value;
        this.http.post(`${environment.apiUrl}/update-password`, { oldPassword, newPassword }).subscribe({
            next: (res: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Password updated successfully!',
                });
                this.updatePasswordForm.reset();
            },
            error: (err: any) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: err.error || 'Password update failed!',
                });
            },
        });
    }
}
